<template>
	<div id="inbox-thread-input" class="tw-pb-4 tw-px-4 tw-bg-white">
		<div class="tw-relative">
			<huddle-editor-v2 v-model="message"
				:submit_on_enter="true"
				:prevent_submit="this.disableSent"
				:mentions="true"
				:emojis="true"
				:gifs="true"
				ref="editorFroala"
				:images="true"
				:placeholder="translations['messages.type_message']"
				:mobile_send_btn="true"
				:submittable="true"
				@submit="sendMessage"
				@onkeydown="isTyping"
				:multi_line="true"
                @imageUploading="imageUploading"
				:fileTypes="'.jpg, .pdf, .docx, .doc, .png, .jpeg, .gif, .bmp, .heic, .heif, .JPG, .PNG, .JPEG, .GIF, .BMP, .HEIC, .HEIF'"
				class="tw-rounded-full">
			</huddle-editor-v2>
			<!-- <img :src="avatar" class="tw-w-16 tw-h-16 tw-rounded-full tw-absolute tw-top-0 tw-left-0 " /> -->
			<div class=" tw-rounded-full tw-absolute tw-top-0 tw-left-0 tw--mt-4">
			</div>
		</div>
	</div>
</template>

<script>
import HuddleEditorV2 from '../HuddleEditorV2.vue';
import NotificationCentre from '../../mixins/NotificationCentre';
import Global from '../../mixins/Global.js';

const debounce = require('lodash.debounce');

export default {
	name: 'ThreadInput',
	props: ['newParticipant', 'setActiveThread', 'activeThread'],
	mixins: [Global, NotificationCentre],
	data() {
		return {
			message: '',
			disableSent: false
		};
	},
	components: {
		'huddle-editor-v2': HuddleEditorV2,
	},
	watch: {
		activeThread: function (newValue, oldValue) {
			if (oldValue !== newValue && newValue !== null) {
				// focus on input when thread changes
				this.focusInput();
			}
		},
	},
	computed: {
		me() {
			return this.$user;
		}
	},
	methods: {
		isTyping: debounce(function() {
            this.whisper(this.activeThread);
        }, 250),
		focusInput() {
			const editor = this.$refs.editorFroala.$refs.froala.getEditor();
			editor.el.focus();
		},
		imageUploading(uploading) {
			this.disableSent = uploading;
		},
		async sendMessage(payload) {
			if(this.disableSent) {
				alert(this.translations['messages.wait_for_upload']);
				return;
			}

			if(this.newParticipant === null) {
				this.submitNewMessage(payload);
			} else {
				// check if thread already exists
				const response = await Thread.api().getThreadByUserId(this.newParticipant.id);
				const foundThread = response.response.data.data;
				// if so, send message to this thread
				if(foundThread.id) {
					this.submitNewMessage(payload, foundThread.id);
				} else {
					this.startNewThread(payload);
				}
			}

			// finally, focus back on input to continue typing
			setTimeout(() => {
				this.focusInput();
			},0);
		},
		submitNewMessage(payload, threadId = null) {
			const messageData = this.getMessageData(payload);
			const sendThreadId = threadId ? threadId : this.activeThread;

			Message.api().send(sendThreadId, messageData).then(() => {
				this.setActiveThread(sendThreadId);
			});

		},
		startNewThread(payload) {
			const messageData = this.getMessageData(payload);
			const fakeTheadId = this.generateUUID();
			const fakeMessageId = this.generateUUID();

			const message = {};
			message.id = fakeMessageId;
			message.thread_id = fakeTheadId;
			message.fake_thread_id = fakeTheadId;
			message.body = messageData.message;
			message.user_id = user.id;
			message.mine = true;
			message.not_send = true;
			message.new = true;

			const now = new Date();
			//2021-06-07 10:31:07
			const created_at = `${ now.getFullYear() }-${ now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1 }-${ now.getDate() < 10 ? '0' + now.getDate() : now.getDate() } ${ now.toLocaleString('nl-NL').split(' ')[1] }`;

			message.created_at = created_at;

			const thread = {};
			thread.id = fakeTheadId;
			thread.unread = false;
			thread.partners = [self.user, this.newParticipant];
			thread.last_activity = created_at;
			thread.messages = [message];
			thread.sent_message_ids = [fakeMessageId];

			Message.insert({
				data: [
					message
				],
			});

			Thread.insert({
				data: [
					thread
				]
			});

			this.$emit('set-fake-thread');
			this.setActiveThread(fakeTheadId);

			this.$emit('set-loading-new-thread-sceen');
			Thread.api().start(messageData, this.newParticipant, fakeTheadId).then((response) => {
				const newThreadId = response.response.data.data.id;
			    this.$emit('remove-loading-new-thread-sceen');
				this.setActiveThread(newThreadId);
				this.$emit('remove-fake-thread');

				Thread.delete(fakeTheadId);
				Message.delete(fakeMessageId);
			});
		},
		getMessageData(payload) {
			let data;
			// if content is present then it is a normal text submit
			if(typeof payload.content !== 'undefined') {
				if (payload.content !== '') {
					data = {
						'message': payload.content,
						'upload_uuids': payload.imagesUUIDs,
						'image_preview': payload.imagesPreview
					};
				}
			} else {
				// else it's a GIF
				data = {
					'message': '<img src="' + payload.gif + '">',
					'upload_uuids': []
				};
			}
			return data;
		}
	},
	mounted() {
		this.$refs.editorFroala.initialize(true);
	},
};
</script>

<style lang="scss">
    #inbox-thread-input {
        .message-body {
            img {
                @apply tw-rounded;
            }
        }

        .froala-wrapper {
            .fr-toolbar .fr-command {
                border-radius: 9999px !important;
            }

            .fr-box {
                border-radius: 26px !important;

                .fr-element {
                    padding-left: 20px !important;
                }
                .fr-placeholder {
                    margin-left: 7px !important;
                }
            }

            .image-previews {
                padding: 0px;
                background: #F7F7F7;
                opacity:1;
                z-index: 10;
                right: 20px !important;

                .image-preview{
                    background: none;
                    margin: 0px !important;
                    padding: 10px !important;

                    img, p {
                        border-radius: 3px;
                        background: white;
                        transition: border 0.3s ease-in-out;
                        border: 2px solid transparent;
                        padding: 12px 8px 12px 8px !important;
                        box-shadow: 0px 5px 5px rgba(0,0,0,0.3);
                        color:black;
                        word-break: break-word;
                    }
                }

            }
        }
    }
</style>
